// extracted by mini-css-extract-plugin
export var arrow = "Arrow-module--arrow--65698";
export var path = "Arrow-module--path--88231";